// extracted by mini-css-extract-plugin
export default {"page":"page_uab2Z","isWebView":"isWebView_vD5Bb"};